import React, {useEffect, useState} from "react";
import Card from "../../components/Base/Card";
import {FiArrowLeft} from "react-icons/fi";
import BaseDatePicker from "../../components/Base/BaseDatePicker";
import SuccessModal from "../../components/SuccessModal";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import ErrorViewer from "../../components/ErrorViewer";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {CreateNextOfKin, getBanks, GetRelationship, UpdateNextOfKin} from "../../redux/selfService/selfServiceSlice";
import {getCountries, getLGA, getStates} from "../../redux/utils/utilsSlice";
import LoadingSpinner from "../../components/LoadingSpinner";
import { Country, ICountry } from "country-state-city";


interface PropsI {
    // isCreateMode?: boolean;
    isEditMode: boolean;
    onClose : ()=>void;
    nok: any;
}
 
const ViewBeneficiary = ({ isEditMode=false, onClose, nok }: PropsI) => {
    const dispatch = useAppDispatch();
    const [showSuccessModal, setShowSuccessModal] = useState(false)
    const { relationships, isLoading, allBanks } = useAppSelector((state) => state?.selfService);
    const [countries, setCountries] = useState<ICountry[]>()
    const { allStates, allCountries,lgas } = useAppSelector((state) => state?.utils);
    const [isBeneficiary, setIsBeneficiary] = useState(0)
    console.log('is edit mode ', isEditMode);

    useEffect(()=>{
        if(isEditMode) {
           // setCountries(Country.getAllCountries());

            dispatch(getCountries());
            dispatch(getStates());
            dispatch(getBanks());
            dispatch(GetRelationship())
        }
    }, [])

    const validationSchema = Yup.object().shape({
        txtnokfirstname: Yup.string().required("Firstname is required"),
        txtNokOthernames: Yup.string(),
        txtnoksurname: Yup.string().required("Surname is required"),
        dteDob: Yup.string().required("Date of birth is required"),
        relationshipId: Yup.string().required("Please select relationship"),
        noktxtmobile: Yup.string().required("Phone number is required"),
        noktxtaddress: Yup.string().required("Address is required"),
        noktxtaddress1: Yup.string().required("Address is required"),
        lgaofResidenceId: Yup.string().required("LGA is required"),
        lgaofResidenceText:Yup.string(),
        txtStateCode: Yup.string().required("Please select a state"),
        txtEmailAddress: Yup.string().email("Not a valid email address").required("Email is required"),
        noktxtgender: Yup.string().required("Please select Gender"),
        noktxttitle: Yup.string().required("Title is required"),
        noktxtLga: Yup.string(),
        countryId: Yup.number().required("Please select"),
        nationality:Yup.string().required("Nationality is required"),
        isPrimary: Yup
            .string()
            .when("isBeneficiary", {
                is: (val:string)=>val==="1",
                then: ()=>Yup.string().required('Please Select'),
            }),
        beneficiaryPercentage: Yup
            .string()
            .when("isBeneficiary", {
                is: (val:string)=>val==="1",
                then: ()=>Yup.string().required('Please enter beneficiary percentage'),
            }),
        noktxtcity: Yup.string().required("Title is required"),
        // countryId: 0,
        txtNokTownOfOrigin: Yup.string().required("Town is required"),
        isBeneficiary:Yup.string().required("Please select"),
        bvn: Yup.string().required("Please enter bvn"),
        nin: Yup.string().required("please enter nin"),
        bankId: Yup.string().required("please select bank"),
        accountNumber: Yup.string().required("please enter account number"),
        
        
    });

    const { handleSubmit, register, setValue, formState: { errors },} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: {
            txtnoksurname: "",
            txtnokfirstname: "",
            txtNokOthernames: "",
            dteDob: new Date().toISOString(),
            relationshipId: "0",
            noktxttitle: "",
            noktxtgender: "",
            noktxtmobile: "",
            noktxtaddress: "",
            noktxtaddress1: "",
            noktxtcity: "",
            lgaofResidenceId: "0",
            lgaofResidenceText:"",
            txtEmailAddress: "",
            beneficiaryPercentage: "0",
            txtStateCode: "",
            noktxtLga: "",
            countryId: 0,
            isPrimary: "0",
            txtNokTownOfOrigin: "",
            isBeneficiary: "0",
            bvn: "",
            nin: "",
            bankId: "0",
            accountNumber: "0",
            nationality:""
        }
    });

    const onStateCodeChanged = (stateCode: string)=>{
        dispatch(getLGA({ stateCode }))
    }

    const onSubmit = async (values: any) => {
    var updateAction =await dispatch(CreateNextOfKin({
            ...values,
            dteDob: new Date(values.dteDob).toISOString(),
            noktxtLga: values.lgaofResidenceText,
            countryId:values.nationality,
            isPrimary: parseInt(values.isPrimary, 10),
            isBeneficiary: parseInt(values.isBeneficiary, 10),
        }));

        // if(updateKYCAction?.type==="selfService/UpdateKYC/fulfilled" && updateKYCAction.payload.statusCode === "00"){
        //     setShowSuccessModal(true)
        //     onSuccess();
        // }
        if (updateAction?.type === "selfService/CreateNextOfKin/fulfilled" && updateAction?.payload?.statusCode === "00") {
            setShowSuccessModal(true);
          }
    }

    const Required = ()=>(<span className="text-danger">*</span>)

    console.log('errors na ', errors);

    return (
        <div className="settings-page">
            <SuccessModal
                showModal={showSuccessModal}
                onClose={()=>setShowSuccessModal(false)}
                note={"Your account has been updated successfully."}
            />
            <div className="flex text-primary mb-4">
                <button className="btn btn-outline font-semibold mr-4" onClick={onClose}>
                    <FiArrowLeft className="mr-1 text-xl"/>
                    Back
                </button>
            </div>


                <div className="h1 mt-16 text-grayscaleBody">
                    {!isEditMode ?
                        "Beneficiary Information" : "Add Beneficiary"
                    }
                </div>
            {!isEditMode ?
                <div className="w-full">
                    <Card className="mb-8 bg-grayscaleBG">
                        <div className="section-card">
                            <div className="pt-12">
                                Beneficiary Personal Information
                            </div>
                            <table className="w-full">
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Surname:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.txtnoksurname ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Firstname:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.txtnokfirstname ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Other Names:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.txtNokOthernames ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Title:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.noktxttitle ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Gender:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.noktxtgender ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Relationship:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.relationship ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Date of Birth:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.dteDob ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Email Address:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.txtEmailAddress ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Phone Number:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.noktxtmobile ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Address:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.noktxtaddress ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Address1:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.noktxtaddress1 ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                City:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.noktxtcity ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                State:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.txtState ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Local Government:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.lgaofName ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Town of Origin:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.txtNokTownOfOrigin ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Card>
                    <Card className="mb-8 bg-grayscaleBG">
                        <div className="section-card">
                            <div className="pt-12">
                                Bank Information
                            </div>
                            <table className="w-full">
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Beneficiary:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.isBeneficiary ? "Yes" : "No"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Primary Beneficiary                                            </div>
                                            <div className="info__group--text">
                                                {nok.isPrimary? "Yes" : "No"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Beneficiary Percentage:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.beneficiaryPercentage ? `${nok.beneficiaryPercentage}%` : "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Beneficiary Balance:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.beneficiaryBalance ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Gratuity ID:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.gratuityId ? `${nok.gratuityId}%` : "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Bank ID:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.bankId ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="info__row">
                                    <td>
                                        <div className="info__group">
                                            <div className="info__group--label">
                                                Account Number:
                                            </div>
                                            <div className="info__group--text">
                                                {nok.accountNumber ?? "N/A"}
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Card>

                    <div className="flex justify-end text-primary mb-4">
                        <button className="btn btn-primary font-semibold mr-4" onClick={onClose}>
                            Continue
                        </button>
                    </div>
                </div>
                :
                <div className="w-full">
                    <Card className="mb-8 bg-grayscaleBG">
                        <div className="section-card">
                            <div className="pt-12">
                                Next of Kin Personal Information
                            </div>
                            <div className="w-full">
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="firstName" className="form__label">
                                            First Name: <Required />
                                        </label>
                                        <input id="firstName" placeholder="First Name" type="text" className="form__input" {...register("txtnokfirstname")} />
                                        {errors.txtnokfirstname && (
                                            <ErrorViewer message={errors.txtnokfirstname.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="lastname" className="form__label">Surname: <Required /></label>
                                        <input placeholder="Last Name" type="text" id="lastname"
                                               className="form__input" {...register("txtnoksurname")} />
                                        {errors.txtnoksurname && (
                                            <ErrorViewer message={errors.txtnoksurname.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="othernames" className="form__label">
                                            Other Name:
                                        </label>
                                        <input placeholder="Other Names" type="text" id="othernames"
                                               className="form__input" {...register("txtNokOthernames")} />
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="title" className="form__label">
                                            Title: <Required />
                                        </label>
                                        <select id="title" className="form__select" {...register("noktxttitle")} >
                                            <option value="">Select Title</option>
                                            <option value="mr">Mr</option>
                                            <option value="mrs">Mrs</option>
                                            <option value="miss">Miss</option>
                                        </select>
                                        {errors.noktxtgender && (
                                            <ErrorViewer message={errors.noktxtgender.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="gender" className="form__label">Gender: <Required /></label>
                                        <select id="gender" className="form__select" {...register("noktxtgender")} >
                                            <option value="M">Male</option>
                                            <option value="F">Female</option>
                                        </select>
                                        {errors.noktxtgender && (
                                            <ErrorViewer message={errors.noktxtgender.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="" className="form__label">
                                            Date of Birth: <Required />
                                        </label>
                                        <BaseDatePicker
                                            onChange={(date) => {
                                                setValue("dteDob", date.toISOString());
                                            }}
                                        />
                                        {errors.dteDob && (
                                            <ErrorViewer message={errors.dteDob.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="email" className="form__label">
                                            Email Address: <Required />
                                        </label>
                                        <input placeholder="Email Address" type="email" id="email"
                                               className="form__input" {...register("txtEmailAddress")} />
                                        {errors.txtEmailAddress && (
                                            <ErrorViewer message={errors.txtEmailAddress.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="phone-number" className="form__label">
                                            Phone Number: <Required />
                                        </label>
                                        <input placeholder="Phone Number" type="text" id="phone-number"
                                               className="form__input" {...register("noktxtmobile")} />
                                        {errors.noktxtmobile && (
                                            <ErrorViewer message={errors.noktxtmobile.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="relationship" className="form__label">
                                            Relationship <Required />
                                        </label>
                                        <select id="relationship" className="form__select" {...register("relationshipId")} >
                                            <option value="">Select Relationship</option>
                                            {
                                                relationships && relationships.length > 0 && relationships.map(relationship=>(
                                                    <option value={relationship.id}>{relationship.txtRelationshipType}</option>
                                                ))
                                            }
                                        </select>
                                        {errors.relationshipId && (
                                            <ErrorViewer message={errors.relationshipId.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="street-address" className="form__label">
                                            Address: <Required />
                                        </label>
                                        <input placeholder="Address" type="text" id="street-address"
                                               className="form__input" {...register("noktxtaddress")} />
                                        {errors.noktxtaddress && (
                                            <ErrorViewer message={errors.noktxtaddress.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="street-address1" className="form__label">
                                            Address 1: <Required />
                                        </label>
                                        <input placeholder="Alternate Address" type="text" id="street-address1"
                                               className="form__input" {...register("noktxtaddress1")} />
                                        {errors.noktxtaddress1 && (
                                            <ErrorViewer message={errors.noktxtaddress1.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="city" className="form__label">City: <Required /></label>
                                        <input placeholder="City" type="text" id="city" className="form__input" {...register("noktxtcity")}  />
                                        {errors.noktxtcity && (
                                            <ErrorViewer message={errors.noktxtcity.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">

                                <div className="form__group">
                        <label htmlFor="nationality" className="form__label">
                            Nationality <Required/>
                        </label>
                        <select id="nationality" className="form__select"
                        
                        onChange={(e) => {
                            // Get the selected option text
                            const selectedOption = e.target.options[e.target.selectedIndex];
                            // const selectedText = selectedOption.text;
                          
                           setValue('nationality', e.target.value);
                           
               // Set lgaofResidenceText to the selected text
            //    setValue('lgaofResidenceText', selectedText);
                            
                       }}



                        {...register("nationality")}>
                             
                                {allCountries && allCountries.length > 0 ? (
                                    allCountries.map((country, index) => (
                                      <option
                                        key={`${country.id}-${index}`}
                                        value={country.id}


                                      >
                                        {country.txtcountryName}
                                      </option>
                                    ))
                                  ) : (
                                    <option value="">No countries available</option>
                                  )}
                            
{/* 
{allCountries && Object.keys(allStates).map((a) => (
                                                <option value={a} key={a}>{allCountries[a]}</option>
                                            ))} */}
                        </select>
                    </div>
                                </div>
                                <div className="form__row">
                               


                                    
                                    <div className="form__group">
                                        <label htmlFor="state" className="form__label">
                                            State: <Required />
                                        </label>
                                        <select id="state" defaultValue=""
                                                className="form__select"
                                                onChange={(e) => {
                                                     // Get the selected option text
                                                     const selectedOption = e.target.options[e.target.selectedIndex];
                                                     const selectedText = selectedOption.text;
                                                    onStateCodeChanged(e.target.value);
                                                    setValue('txtStateCode', e.target.value);
                                                    setValue('lgaofResidenceId', "0");
                                                    
                                        // Set lgaofResidenceText to the selected text
                                        setValue('lgaofResidenceText', selectedText);
                                                     
                                                }}
                                        >
                                            <option value="" disabled>Select State</option>
                                            {allStates && Object.keys(allStates).map((a) => (
                                                <option value={a} key={a}>{allStates[a]}</option>
                                            ))}
                                        </select>
                                        {errors.txtStateCode && (
                                            <ErrorViewer message={errors.txtStateCode.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="lga" className="form__label">
                                             LGA: <Required />
                                        </label>
                                        <select id="lga" defaultValue=""
                                                className="form__select"
                                                {...register('lgaofResidenceId')}
                                        >
                                            <option value="" disabled>Select LGA</option>
                                            {lgas && Object.keys(lgas).map((lgaKey) => (
                                                <option value={lgaKey} key={lgaKey}>{lgas[lgaKey]}</option>
                                            ))}
                                        </select>
                                        {errors.lgaofResidenceId && (
                                            <ErrorViewer message={errors.lgaofResidenceId.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="town-of-origin" className="form__label">
                                            Town of Origin <Required />
                                        </label>
                                        <input placeholder="NoK Town Of Origin" type="text" id="town-of-origin"
                                               className="form__input" {...register("txtNokTownOfOrigin")} />
                                        {errors.txtNokTownOfOrigin && (
                                            <ErrorViewer message={errors.txtNokTownOfOrigin.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="isBeneficiary" className="form__label">
                                            Is Beneficiary <Required />
                                        </label>
                                        <select id="isBeneficiary" defaultValue=""
                                                className="form__select"
                                                onChange={(e)=>{
                                                    setIsBeneficiary(parseInt(e.target.value, 10));
                                                    // @ts-ignore
                                                    setValue('isBeneficiary', e.target.value)
                                                }}
                                        >
                                            <option value="" disabled>Select Option</option>
                                            <option value="0">False</option>
                                            <option value="1">True</option>
                                        </select>
                                        {errors.isBeneficiary && (
                                            <ErrorViewer message={errors.isBeneficiary.message as string}/>
                                        )}
                                    </div>
                                </div>
                                {
                                    isBeneficiary === 1 &&(
                                        <div className="form__row">
                                            <div className="form__group">
                                                <label htmlFor="isPrimary" className="form__label">
                                                    Is primary  <Required />
                                                </label>
                                                <select id="isPrimary" defaultValue=""
                                                        className="form__select"
                                                        {...register('isPrimary')}
                                                >
                                                    <option value="" disabled>Select LGA</option>
                                                    <option value="0">False</option>
                                                    <option value="1">True</option>
                                                </select>
                                                {errors.isPrimary && (
                                                    <ErrorViewer message={errors.isPrimary.message as string}/>
                                                )}
                                            </div>
                                            <div className="form__group">
                                                <label htmlFor="beneficiaryPercentage" className="form__label">
                                                    Beneficiary Percentage(%): <Required />
                                                </label>
                                                <input placeholder="0" type="number" id="beneficiaryPercentage"
                                                       className="form__input" {...register("beneficiaryPercentage")} />
                                                {errors.isPrimary && (
                                                    <ErrorViewer message={errors.isPrimary.message as string}/>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="bvn" className="form__label">
                                            BVN <Required />
                                        </label>
                                        <input placeholder="BVN" type="number" id="bvn"
                                               className="form__input" {...register("bvn")} />
                                        {errors.bvn && (
                                            <ErrorViewer message={errors.bvn.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="nin" className="form__label">
                                            NIN <Required />
                                        </label>
                                        <input placeholder="NIN" type="number" id="nin"
                                               className="form__input" {...register("nin")} />
                                        {errors.nin && (
                                            <ErrorViewer message={errors.nin.message as string}/>
                                        )}
                                    </div>
                                </div>
                                <div className="form__row">
                                    <div className="form__group">
                                        <label htmlFor="bank-id" className="form__label">
                                            Bank <Required />
                                        </label>
                                        <select id="bankId" className="form__select" {...register("bankId")} >
                                            <option value="">Select Bank</option>
                                            {
                                                Object.keys(allBanks.banks).length > 0 && Object.keys(allBanks.banks).map((bankId: any) =>
                                                    <option value={bankId} key={bankId}>{allBanks.banks[bankId]}</option>
                                                )
                                            }
                                        </select>
                                        {errors.bankId && (
                                            <ErrorViewer message={errors.bankId.message as string}/>
                                        )}
                                        {errors.bvn && (
                                            <ErrorViewer message={errors.bvn.message as string}/>
                                        )}
                                    </div>
                                    <div className="form__group">
                                        <label htmlFor="account-number" className="form__label">
                                            Account Number <Required />
                                        </label>
                                        <input placeholder="" type="number" id="account-number"
                                               className="form__input" {...register("accountNumber")} />
                                        {errors.accountNumber && (
                                            <ErrorViewer message={errors.accountNumber.message as string}/>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Card>
                  
                    <div className="flex justify-end text-primary mb-4">
                        <button
                            className="btn btn-primary font-semibold mr-4"
                            onClick={handleSubmit(onSubmit)}
                            disabled={isLoading}
                        >
                            { isLoading ? <LoadingSpinner /> : "Add Beneficiary"}
                        </button>
                    </div>
                </div>
            }


        </div>
    );
}
export default ViewBeneficiary;